import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import {
  HospitalMasterCreateRequestDTO,
  HospitalMasterDeleteRequestDTO,
  HospitalMasterDTO,
  HospitalMasterGetSummaryByHospitalRequestDTO,
  HospitalMasterGetSummaryByHospitalResponseDTO,
  HospitalMasterList,
  HospitalMasterOnBoardingCompleteRequestDTO,
  HospitalMasterReadByHospitalIdOwnerList,
  HospitalMasterReadByIdRequestDTO,
  HospitalMasterUpdateRequestDTO,
  HosptialMasterSmallHospitalDashboardKPIRequestDTO,
  HosptialMasterSmallHospitalDashboardKPIResponseDTO,
  MenuMasterCreateRequestDTO,
  MenuMasterDeleteRequestDTO,
  MenuMasterResponseDTO,
  MenuMasterUpdateRequestDTO,
  ReadByHospitalIdOwnerRequestDTO,
} from "./hospital-master.interface";
import { Observable } from "rxjs";
import {
  HospitalMaster_Create,
  HospitalMaster_Delete,
  HospitalMaster_ExternalReadById,
  HospitalMaster_GetSummaryByHospital,
  HospitalMaster_OnboardingComplete,
  HospitalMaster_OnboardingReadAllPaginated,
  HospitalMaster_ReadAll,
  HospitalMaster_ReadAllPaginated,
  HospitalMaster_ReadByHospitalIdOwner,
  HospitalMaster_ReadById,
  HospitalMaster_Update,
  HosptialMaster_SmallHospitalDashboardKPI,
  MenuMaster_create,
  MenuMaster_delete,
  MenuMaster_readAll,
  MenuMaster_update,
} from "src/app/GlobalVariable/Hospital.GlobalVariable";
import { PaginatedDTO } from "src/app/Common/common.interface";


@Injectable({
  providedIn: "root",
})
export class HospitalMasterService {
  constructor() {}

  http = inject(HttpClient);

  HospitalMaster_Create(
    data: HospitalMasterCreateRequestDTO,
  ): Observable<HospitalMasterDTO> {
    return this.http.post<HospitalMasterDTO>(HospitalMaster_Create, data);
  }

  HospitalMaster_Update(
    data: HospitalMasterUpdateRequestDTO,
  ): Observable<HospitalMasterDTO> {
    return this.http.post<HospitalMasterDTO>(HospitalMaster_Update, data);
  }

  HospitalMaster_ReadAll(): Observable<HospitalMasterList> {
    return this.http.get<HospitalMasterList>(HospitalMaster_ReadAll);
  }

  HospitalMaster_ReadById(
    data: HospitalMasterReadByIdRequestDTO,
  ): Observable<HospitalMasterDTO> {
    return this.http.post<HospitalMasterDTO>(HospitalMaster_ReadById, data);
  }

  HospitalMaster_ExternalReadById(
    data: HospitalMasterReadByIdRequestDTO,
    xApiKey?: string,
    xApiTimestamp?: string,
    xApiNonce?: string,
    xApiSignature?: string
  ): Observable<HospitalMasterDTO> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (xApiKey && xApiSignature) {
      headers = headers
        .set('X-Api-Key', xApiKey)
        .set('X-Api-Timestamp', xApiTimestamp || '')
        .set('X-Api-Nonce', xApiNonce || '')
        .set('X-Api-Signature', xApiSignature);
    }
    return this.http.post<HospitalMasterDTO>(
      HospitalMaster_ExternalReadById,
      data,
      { headers }
    );
  }

  HospitalMaster_Delete(
    data: HospitalMasterDeleteRequestDTO,
  ): Observable<void> {
    return this.http.post<void>(HospitalMaster_Delete, data);
  }

  HospitalMaster_OnBoardingComplete(
    data: HospitalMasterOnBoardingCompleteRequestDTO,
  ): Observable<void> {
    return this.http.post<void>(HospitalMaster_OnboardingComplete, data);
  }

  HospitalMaster_OnboardingReadAllPaginated(
    data: PaginatedDTO,
  ): Observable<HospitalMasterList> {
    return this.http.post<HospitalMasterList>(
      HospitalMaster_OnboardingReadAllPaginated,
      data,
    );
  }

  HospitalMaster_ReadAllPaginated(
    data: PaginatedDTO,
  ): Observable<HospitalMasterList> {
    return this.http.post<HospitalMasterList>(
      HospitalMaster_ReadAllPaginated,
      data,
    );
  }

  HospitalMaster_GetSummaryByHospital(
    data: HospitalMasterGetSummaryByHospitalRequestDTO,
  ) {
    return this.http.post<HospitalMasterGetSummaryByHospitalResponseDTO>(
      HospitalMaster_GetSummaryByHospital,
      data,
    );
  }

  HosptialMaster_SmallHospitalDashboardKPI(
    data: HosptialMasterSmallHospitalDashboardKPIRequestDTO,
  ): Observable<HosptialMasterSmallHospitalDashboardKPIResponseDTO> {
    return this.http.post<HosptialMasterSmallHospitalDashboardKPIResponseDTO>(
      HosptialMaster_SmallHospitalDashboardKPI,
      data,
    );
  }

    HospitalMaster_ReadByHospitalIdOwner(
    data: ReadByHospitalIdOwnerRequestDTO,
  ): Observable<HospitalMasterReadByHospitalIdOwnerList> {
    return this.http.post<HospitalMasterReadByHospitalIdOwnerList>(
      HospitalMaster_ReadByHospitalIdOwner,
      data,
    );
  }

  MenuMaster_create(
    data: MenuMasterCreateRequestDTO,
  ): Observable<MenuMasterResponseDTO> {
    return this.http.post<MenuMasterResponseDTO>(
      MenuMaster_create,
      data,
    );
  }

  MenuMaster_readAll(): Observable<MenuMasterResponseDTO[]> {
  return this.http.get<MenuMasterResponseDTO[]>(MenuMaster_readAll);
  }

    MenuMaster_update(
    data: MenuMasterUpdateRequestDTO,
  ): Observable<MenuMasterResponseDTO> {
    return this.http.post<MenuMasterResponseDTO>(MenuMaster_update, data);
  }

      MenuMaster_delete(
    data: MenuMasterDeleteRequestDTO,
  ): Observable<MenuMasterResponseDTO> {
    return this.http.post<MenuMasterResponseDTO>(MenuMaster_delete, data);
  }

}
